import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MiscellaneousService {
  constructor() {}

  public previousHeader: Subject<void> = new Subject<void>();

  public isCancelled: Subject<boolean> = new Subject<boolean>();

  public closePopup: Subject<boolean> = new Subject<boolean>();

  clear() {
    this.previousHeader.complete();
    this.previousHeader = new Subject<void>();

    this.isCancelled.complete();
    this.isCancelled = new Subject<boolean>();

    this.closePopup.complete();
    this.closePopup = new Subject<boolean>();
  }
}
